import { render, staticRenderFns } from "./RegisterComplete.vue?vue&type=template&id=746a1aa0&scoped=true&"
import script from "./RegisterComplete.vue?vue&type=script&lang=js&"
export * from "./RegisterComplete.vue?vue&type=script&lang=js&"
import style0 from "./RegisterComplete.vue?vue&type=style&index=0&id=746a1aa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746a1aa0",
  null
  
)

export default component.exports